<template>
	<div class="container">
		<div class="form">
			<h3>预约看房</h3>
			<van-cell-group>
				<van-field v-model="typeName" class="item" placeholder="选择所享服务" readonly clickable right-icon="arrow" @click="showPicker = true" />
				<van-field class="item" v-model="date" placeholder="选择看房时间" readonly right-icon="arrow" @click="showBeginDate" />
				<van-popup v-model="showPickerDate" position="bottom">
					<van-datetime-picker v-model="currentDate" type="date" @cancel="onCancelDate" @confirm="onConfirmDate" :min-date="minDate" :max-date="maxDate" />
				</van-popup>
				<van-popup v-model="showPickerTime" position="bottom">
					<van-datetime-picker v-model="currentTime" type="time" @cancel="onCancelTime" @confirm="onConfirmTime" />
				</van-popup>
				<van-field maxlength="15" v-model="name" placeholder="请输入看房人姓名" />
				<van-field maxlength="11" v-model="phone" placeholder="请输入看房人电话" :error-message="phoneErrorMessage" @blur="isValidPhone" />
				<van-field v-model="code" clearable placeholder="请输入验证码" use-button-slot>
					<van-button slot="button" size="small" type="info" @click="getCode" :disabled="disabled">{{ codeBtnTxt }}</van-button>
				</van-field>
				<van-button style="width: 100%; margin-top: 5px; font-size: 16px" type="info" @click="submit">提交</van-button>
			</van-cell-group>
		</div>
		<van-loading size="50px" vertical v-show="isShow">正在提交...</van-loading>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker v-show="showPicker" show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			date: '',
			name: '',
			phone: '',
			phoneErrorMessage: '',
			code: '',
			isValidPhoneFlag: false,
			codeBtnTxt: '发送验证码',
			showPickerDate: false,
			showPickerTime: false,
			currentDate: '',
			currentTime: '',
			minDate: new Date(),
			maxDate: new Date(2035, 10, 1),
			selectDate: '',
			disabled: false,
			isShow: false,
			columns: [],
			typeList: [],
			showPicker: false,
			typeId: '',
			typeName: '',
		}
	},
	mounted() {
		this.getTypeList()
	},
	methods: {
		getTypeList() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/properties`,
				{ type: 10, communityId: this.$route.query.communityId },
				(res) => {
					if (res.data.length === 0) return
					res.data.forEach((item) => {
						this.columns.push({
							text: item.name,
							id: item.id,
						})
					})
				},
				function (err) {
					console.log(err)
				}
			)
		},
		showBeginDate() {
			this.showPickerDate = true
		},
		onCancelDate() {
			this.showPickerDate = false
		},
		onConfirmDate(val) {
			this.selectDate = this.formatDate(val)
			this.showPickerDate = false
			this.showPickerTime = true
		},
		onCancelTime() {
			this.showPickerDate = true
			this.showPickerTime = false
		},
		onConfirmTime(val) {
			this.showPickerTime = false
			this.date = `${this.selectDate} ${val}`
		},
		formatDate(date) {
			date = new Date(date)
			let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
			return `${date.getFullYear()}/${month}/${date.getDate()} `
		},
		isValidPhone() {
			var numReg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			this.phoneErrorMessage = !numReg.test(this.phone) ? '请输入正确手机号码' : ''
			this.isValidPhoneFlag = numReg.test(this.phone)
		},
		getCode() {
			let self = this
			self.isValidPhone()
			if (!self.isValidPhoneFlag) return

			// 发送请求获取验证码
			let params = {
				source_type: 1,
				account: self.phone,
				captcha_type: 8,
			}
			self.vaxios.post(`${self.vaxios.host}/open/api/v1/captcha`, params, (res) => {
				if (res === -1) return
				self.$toast('验证码已发送')
				self.disabled = true
				self.createTimer()
			})
		},
		createTimer() {
			let self = this
			let endTime = new Date(new Date().getTime() + 60 * 1000)

			self.codeBtnTxt = '60s后重新获取'
			self.timer = setInterval(() => {
				let diffTime = (Date.parse(new Date(endTime)) - Date.parse(new Date())) / 1000
				if (diffTime < 0) {
					self.codeBtnTxt = '获取验证码'
					self.disabled = false
					clearInterval(self.timer)
					self.timer = null
				} else {
					self.codeBtnTxt = diffTime + 's后重新获取'
					self.disabled = true
				}
			}, 1000)
		},
		submit() {
			let self = this
			if (self.typeId === '') {
				self.$toast('请输入选择所享服务')
				return
			}
			if (self.date === '') {
				self.$toast('请输入选择看房时间')
				return
			}
			if (self.name === '') {
				self.$toast('请输入看房人姓名')
				return
			}
			if (self.phone === '') {
				self.$toast('请输入看房人电话')
				return
			}
			if (self.code === '') {
				self.$toast('请输入验证码')
				return
			}

			self.isShow = true

			// 校验验证码
			let code_params = {
				account: self.phone,
				code: self.code,
				captcha_type: 8,
				source_type: 1,
			}

			self.vaxios.post(
				`${self.vaxios.host}/open/api/v1/match-captcha`,
				code_params,
				(res) => {
					if (res === -1) {
						self.$toast('验证码错误')
						self.isShow = false
					} else {
						let params = {
							id: self.$route.query.id,
							visit_time: new Date(self.date).getTime(),
							contact_name: self.name,
							contact_phone: self.phone,
							property_id_space_product: self.typeId,
						}

						self.vaxios.post(`${self.vaxios.host}/open/api/v1/resources/spaces/apply`, params, (res) => {
							if (res === -1) return
							self.$toast('提交成功')
							self.isShow = false
							self.$router.back(-1)
						})
					}
				},
				(error) => {
					console.log(error)
					self.$toast('验证码错误')
					self.isShow = false
				}
			)
		},
		onConfirm(value) {
			const { id, text } = value
			this.typeName = text
			this.typeId = id
			this.showPicker = false
		},
	},
}
</script>

<style scoped lang="scss">
.container {
	width: 100%;
  height: 100%;
	position: relative;
	overflow-x: hidden;
	padding-top: 30px;
	padding-bottom: 30px;
	.form {
		padding: 0 20px;
		h3 {
			margin-top: 20px;
			margin-bottom: 20px;
			font-weight: normal;
			font-size: 18px;
			text-align: center;
		}
	}
}

.van-cell-group {
	background: transparent;
}
.van-cell {
	width: 100% !important;
	border-radius: 5px;
	background-color: #f6f6f6;
	margin-bottom: 10px;
}
.van-cell__value {
	text-align: left;
}
.van-loading {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(150, 151, 153, 0.7);
}
.van-loading__spinner {
	position: absolute;
	top: 45%;
	left: 45%;
	color: #fff;
}
.van-loading__text {
	position: absolute;
	top: 53%;
	left: 44%;
	color: #fff;
}
</style>
